import React from 'react'
import { Navigate } from 'react-router-dom'

const IframeOnlyRoute = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const isInIframe = window.self !== window.top

  if (!isInIframe) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default IframeOnlyRoute
